import { Component, inject } from '@angular/core';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { AppService } from './services/app.service';

import { Platform } from '@ionic/angular';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support';
import { SplashScreen } from '@capacitor/splash-screen';
import { AppVersionService } from './services/app-version.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent {
  private _app = inject(AppService);
  private _platform = inject(Platform);
  private _appVersion = inject(AppVersionService);

  constructor() {
    this._platform
      .ready()
      .then(() => this._app.initLanguage())
      .then(() => this._app.initMarketingConsents())
      .then(() => this._app.init())
      .then(() => {
        EdgeToEdge.enable();
        SplashScreen.hide();
        this._appVersion.checkVersion();
      });
  }

}
